<div class="attachment-list">
  <div class="header paragraph-large-medium">
    <img *ngIf="imageUrl" [src]="imageUrl" alt="Icon" class="title-icon" />
    {{ title }}
  </div>

  <ng-container *ngIf="isVendorDocument; else remainingAttachmentTemplates">
    <div class="two-column-container">
      <!-- Headers -->
      <div class="column">
        <div class="sub-header paragraph-small-regular">Filename</div>
      </div>
      <div class="column">
        <div class="sub-header paragraph-small-regular">Vendors to receive</div>
      </div>

      <!-- Rows -->
      <ng-container *ngFor="let attachment of dataAttachment">
        <div class="column">
          <div class="link paragraph-medium-regular filelist vendorFile" tabindex="0"
            (keypress)="downloadAttactment(attachment)" (click)="downloadAttactment(attachment)">
            {{ attachment.FileName | truncateMiddle:56 }}
          </div>
        </div>
        <div class="column">
          {{ getTaggedVendorNames(attachment) }}
        </div>
      </ng-container>
    </div>
  </ng-container>

  <ng-template #remainingAttachmentTemplates>
    <div class="sub-header paragraph-small-regular">Filename</div>
    <div class="link paragraph-medium-regular filelist" *ngFor="let attachment of dataAttachment" tabindex="0"
      (keypress)="downloadAttactment(attachment)" (click)="downloadAttactment(attachment)">
      {{ attachment.FileName }}
    </div>
  </ng-template>
</div>